<template>
  <div class="deliveryMobBox">
    <div class="text-wrap">
      <img alt="" src="/assets/images/builds/rocket-ic.svg">
      <p class="fs-14">
        <strong>{{ trans['free_shipping'] }}</strong> {{ trans['worldwide'] }}
      </p>
    </div>
    <div class="text-wrap">
      <img alt="" src="/assets/images/builds/clock-ic.svg">
      <p class="fs-14">
        <strong>{{ trans['delivery_date'] }}</strong> {{ deliveryDate }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['model', 'trans'],
  name: 'DeliveryParameters',
  data() {
    return {
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      }
    }
  },
  computed: {
    deliveryDate() {
      const defaultDate = this.$moment().add(3, 'month').format('MMMM YYYY')
      if (this.model) {
        if (this.model['delivery_date']) {
          return this.months[this.model['delivery_date']['month']] + ' ' + this.model['delivery_date']['year']
        }
        return this.model['delivery_info'] || defaultDate
      }

      return defaultDate
    }
  }
}
</script>

<style lang="scss" scoped>
.deliveryMobBox {
  display: none;
  @media (max-width: 767px) {
    margin-top: -50px;
    background-color: #fff;
    padding: 10px 24px 80px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .text-wrap {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      width: calc(50% - 15px);
      text-align: center;

      img {
        width: 26px;
        min-width: 26px;
        height: 26px;
        margin: 0 auto 16px;
      }

      .fs-14 {
        width: 100%;
        line-height: 1.5;

        strong {
          display: block;
        }
      }
    }
  }

}

</style>
